module.exports = __webpack_public_path__ + "static/ryan-rampersad-2013-large-optimized-10c62c2c462c303f539ebbbb1e4fdfc0.jpg";